<template lang="pug">
  .mr-input(:class="{ 'raise-label': raiseLabel }")
    textarea(
      v-if="inputType == 'textarea'"
      v-bind="combinedAttrs"
      ref="input"
    )

    input(
      v-else
      v-bind="combinedAttrs"
      ref="input"
    )

    label(:for="inputId") {{ label }}

    TransitionExpand
      .input-errors(v-if="inputErrors && inputErrors.length")
        .input-error.xs-f-xsmall.lg-f-xxsmall.max-at-tweak.text-left(role="alert" v-for="error in inputErrors")
          i.icon-warning
          | {{ error }}

</template>

<script>
  import mrInputMixin from './mrInputMixin';

  export default {
    name: "MrInput",
    mixins: [mrInputMixin],

  };
</script>

<style scoped lang="stylus">
  .mr-input
    position relative
    display block
    margin 0.55em 0
    font-size 16px

    label
      position absolute
      top 12px
      left 1.1em
      z-index 1
      cursor text
      pointer-events none
      color #666
      font-size 14px
      line-height 1.3em

    input
    textarea
      border-radius 4px
      transition(border-color 0.6s)

      &.invalid
        border 2px solid color-attention

      &:focus
        border 2px solid brand-color-2

    .customDropdown
      .option.expanded
        z-index 2

    &.raise-label
      label
        top 5px
        font-size 10px
        background-color color-white

      input
      textarea
      .select
        padding-top 15px
        padding-bottom 5px

  .input-error
    color color-attention
</style>
